import { GET_ENTITIES_CORE} from './../constants';
import { handleActions } from "redux-actions"

export const entitiesCore  = handleActions(
  { 
    [ GET_ENTITIES_CORE ]: (state, action) => {
      const {error} = action.payload
      if (error) {
        return state
      } else {
        return action.payload.data
      }
    },
  }, {}
)